export default {
      id: "arrow-back-smooth-usage",
      viewBox: "0 0 24 24",
      url: "/" + "img/marilyn-ui.svg#arrow-back-smooth",
      toString: function () {
        return this.url;
      }
    }